"use strict";

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _AddressV2AutoSuggest = require("./AddressV2AutoSuggest.styled");

var _utils = require("../../utils");

var _AutoSuggest = _interopRequireDefault(require("../../AutoSuggest/AutoSuggest"));

var _FormInput = _interopRequireDefault(require("../../Components/Form/FormInput"));

var _TertiaryButton = _interopRequireDefault(require("../../Buttons/TertiaryButton/TertiaryButton.styled"));

var _nswPointV2Api = _interopRequireDefault(require("./nswPointV2Api"));

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var defaultManualAddressFields = {
  suburb: "",
  state: "",
  postcode: "",
  addressLine: ""
};
var defaultAutoSuggestedAddressFields = Object.assign({}, defaultManualAddressFields, {
  buildingNumber: "",
  country: "",
  formattedAddress: "",
  latitude: "",
  longitude: "",
  nswPointId: "",
  propertyName: "",
  streetName: "",
  streetNumber: "",
  streetType: "",
  unitNumber: "",
  validated: !0
});

var defaultAddressValidator = function defaultAddressValidator(address) {
  if (address.validated) {
    return !0;
  } // eslint-disable-next-line security/detect-object-injection


  return Object.keys(defaultManualAddressFields).every(function (key) {
    return address[key];
  });
};

var AddressAutoSuggest = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2.default)(AddressAutoSuggest, _React$Component);

  function AddressAutoSuggest() {
    var _temp, _this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (_temp = _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this, _this.state = {
      suggestions: [],
      hasReceivedUpdatedPropsOnce: !1,
      address: _this.props.value,
      userSelected: _this.props.value && _this.props.value.validated,
      manualMode: _this.props.initialLoadManual
    }, _this.onSwitchToManual = function () {
      _this.setState({
        address: Object.assign({}, defaultManualAddressFields, {
          validated: _this.props.emptyAddressValid
        }),
        userSelected: !1,
        manualMode: !0
      });

      _this.props.emptyAddressValid ? _this.addressHasBecomeValid() : _this.onAddressHasBecomeInvalid();

      _this.props.onSwitchToManual();
    }, _this.onAddressHasBecomeInvalid = function () {
      var invalidAddress = _this.state.manualMode ? Object.assign({}, _this.state.address) : Object.assign({}, defaultAutoSuggestedAddressFields, {
        validated: !1
      });

      _this.props.onAddressHasBecomeInvalid(invalidAddress);
    }, _this.onSwitchToAutoSuggest = function () {
      _this.setState({
        address: Object.assign({}, defaultAutoSuggestedAddressFields, {
          validated: _this.props.emptyAddressValid
        }),
        userSelected: !0,
        manualMode: !1
      });

      _this.props.emptyAddressValid ? _this.addressHasBecomeValid() : _this.onAddressHasBecomeInvalid();

      _this.props.onSwitchToAutoSuggest();
    }, _this.handleChange = function (key, value) {
      var _Object$assign;

      var updatedAddress = Object.assign({}, _this.state.address, (_Object$assign = {}, _Object$assign[key] = value, _Object$assign));

      _this.setState({
        address: updatedAddress
      }, function () {
        if (_this.props.validator(updatedAddress)) {
          _this.addressHasBecomeValid(updatedAddress, !1);
        } else {
          _this.onAddressHasBecomeInvalid();
        }
      });
    }, _this.fetchSuggestions = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(value) {
        var response, suggestions, isLatest;
        return _regenerator.default.wrap(function (_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.props.backendAPI.getLatestSuggestions(value, _this.props.apiKey, _this.props.apiState, _this.props.apiAddressType, _this.props.apiDataSet);

              case 2:
                response = _context.sent;
                suggestions = response.suggestions, isLatest = response.isLatest;

                if (isLatest) {
                  _this.setState({
                    suggestions: suggestions
                  });
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function () {
        return _ref.apply(this, arguments);
      };
    }(), _this.debouncedFetchSuggestions = debounce(_this.fetchSuggestions, 500), _this.handleChangeAfterSelection = function (updatedAddress) {
      if (!updatedAddress || "" === updatedAddress) {
        _this.setState({
          address: {},
          userSelected: !1
        });

        _this.props.emptyAddressValid ? _this.addressHasBecomeValid(defaultAutoSuggestedAddressFields, !0) : _this.onAddressHasBecomeInvalid();
        return;
      }

      if (_this.state.userSelected) {
        if (updatedAddress !== _this.state.address.formattedAddress) {
          _this.onAddressHasBecomeInvalid();
        } else {
          _this.addressHasBecomeValid(_this.state.address, !0);
        }
      }
    }, _this.addressHasBecomeValid = function (updatedAddress, validated) {
      if (void 0 === validated) {
        validated = !0;
      }

      var completeAddress = Object.assign({}, defaultAutoSuggestedAddressFields, updatedAddress, {
        validated: validated
      });

      _this.props.onAddressHasBecomeValid(Object.assign({}, completeAddress));
    }, _this.selectValue = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(value) {
        var id, address, detailedAddress;
        return _regenerator.default.wrap(function (_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                //suggestion select
                id = value.id, address = value.address;

                if (!("object" == typeof address)) {
                  _context2.next = 5;
                  break;
                }

                _this.onSwitchToManual();

                _context2.next = 10;
                break;

              case 5:
                _context2.next = 7;
                return _this.props.backendAPI.getDetailsById(id, _this.props.apiKey);

              case 7:
                detailedAddress = _context2.sent;

                _this.setState({
                  address: detailedAddress,
                  userSelected: !0
                });

                _this.addressHasBecomeValid(detailedAddress, !0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function () {
        return _ref2.apply(this, arguments);
      };
    }(), _this.handleOnBlur = function (suggestion, value) {
      _this.props.onBlur && _this.props.onBlur(suggestion, value);
    }, _this.clearSuggestions = function () {
      _this.setState({
        suggestions: []
      });

      if (!_this.state.address.validated) {
        _this.setState({
          address: {}
        });
      }
    }, _this.renderSuggestion = function (_ref3) {
      var address = _ref3.address;
      return address;
    }, _this.getSuggestionValue = function (_ref4) {
      var address = _ref4.address;

      if ("string" == typeof address) {
        return address;
      } else {
        return _this.props.value.formattedAddress;
      }
    }, _temp) || (0, _assertThisInitialized2.default)(_this);
  }

  AddressAutoSuggest.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (0 < Object.keys(props.value).length && !state.hasReceivedUpdatedPropsOnce) {
      return {
        address: props.value,
        manualMode: props.initialLoadManual || !1 === props.value.validated,
        hasReceivedUpdatedPropsOnce: !0
      };
    }

    return null;
  };

  var _proto = AddressAutoSuggest.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$state = this.state,
        suggestions = _this$state.suggestions,
        address = _this$state.address,
        manualMode = _this$state.manualMode;
    var _this$props = this.props,
        addressType = _this$props.addressType,
        helpMessage = _this$props.helpMessage,
        manualModeMessage = _this$props.manualModeMessage,
        manualAddressHeading = _this$props.manualAddressHeading,
        id = _this$props.id,
        name = _this$props.name,
        label = _this$props.label,
        disabled = _this$props.disabled,
        placeholder = _this$props.placeholder,
        hasError = _this$props.hasError,
        errorMessage = _this$props.errorMessage;

    var elemID = function genID() {
      return id || (0, _utils.getID)();
    }();

    var _address$addressLine = address.addressLine,
        addressLine = void 0 === _address$addressLine ? "" : _address$addressLine,
        _address$suburb = address.suburb,
        suburb = void 0 === _address$suburb ? "" : _address$suburb,
        _address$state = address.state,
        state = void 0 === _address$state ? "" : _address$state,
        _address$postcode = address.postcode,
        postcode = void 0 === _address$postcode ? "" : _address$postcode,
        formattedAddress = address.formattedAddress;

    var streetAddressLabel = /*#__PURE__*/_react.default.createElement(_AddressV2AutoSuggest.Flex, {
      direction: "row",
      justifyContent: "space-between",
      onClick: function onClick(e) {
        e.preventDefault();
      }
    }, "Street address", /*#__PURE__*/_react.default.createElement(_TertiaryButton.default, {
      textDecoration: "underline",
      onClick: this.onSwitchToAutoSuggest
    }, "Find your address"));

    var autoSuggestLabel = /*#__PURE__*/_react.default.createElement(_AddressV2AutoSuggest.Flex, {
      direction: "row",
      justifyContent: "space-between",
      onClick: function onClick(e) {
        e.preventDefault();
      }
    }, helpMessage, /*#__PURE__*/_react.default.createElement(_TertiaryButton.default, {
      style: {
        textAlign: "right"
      },
      textDecoration: "underline",
      onClick: this.onSwitchToManual
    }, manualModeMessage));

    return /*#__PURE__*/_react.default.createElement("div", {
      className: addressType + "-address"
    }, manualMode ? /*#__PURE__*/_react.default.createElement(_AddressV2AutoSuggest.Container, {
      "data-test": "manualAddressContainer"
    }, /*#__PURE__*/_react.default.createElement(_AddressV2AutoSuggest.Margin, {
      top: 1
    }), /*#__PURE__*/_react.default.createElement(_AddressV2AutoSuggest.StyledAddressLegend, null, manualAddressHeading), /*#__PURE__*/_react.default.createElement(_AddressV2AutoSuggest.StyledFormInput, {
      id: elemID + "-address-line-input",
      className: addressType + "-address-line-input",
      "data-test": "addressLine",
      label: streetAddressLabel,
      value: addressLine,
      maxLength: 255,
      onChange: function onChange(e) {
        return _this2.handleChange("addressLine", e.target.value);
      },
      hasError: hasError && !!errorMessage.addressLine,
      errorMessage: errorMessage.addressLine
    }), /*#__PURE__*/_react.default.createElement(_FormInput.default, {
      id: elemID + "-address-suburb-input",
      className: addressType + "-address-suburb-input",
      "data-test": "suburb",
      label: "Suburb",
      value: suburb,
      maxLength: 40,
      onChange: function onChange(e) {
        return _this2.handleChange("suburb", e.target.value);
      },
      hasError: hasError && !!errorMessage.suburb,
      errorMessage: errorMessage.suburb
    }), /*#__PURE__*/_react.default.createElement(_AddressV2AutoSuggest.Flex, {
      direction: "row"
    }, /*#__PURE__*/_react.default.createElement(_AddressV2AutoSuggest.Dropdown, {
      id: elemID + "-address-state-dropdown",
      className: addressType + "-address-state-dropdown",
      label: "State",
      "data-test": "state",
      options: AddressAutoSuggest.statesCodes,
      value: state,
      maxLength: 20,
      style: {
        marginRight: "1rem"
      },
      onChange: function onChange(e) {
        return _this2.handleChange("state", e.target.value);
      },
      hasError: hasError && !!errorMessage.state,
      errorMessage: errorMessage.state
    }), /*#__PURE__*/_react.default.createElement(_FormInput.default, {
      id: elemID + "-address-postcode-input",
      className: addressType + "-address-postcode-input",
      "data-test": "postcode",
      label: "Postcode",
      value: postcode,
      maxLength: 4,
      onChange: function onChange(e) {
        return _this2.handleChange("postcode", e.target.value);
      },
      hasError: hasError && !!errorMessage.postcode,
      errorMessage: errorMessage.postcode
    })), /*#__PURE__*/_react.default.createElement(_FormInput.default, {
      id: elemID + "-address-country-input",
      className: addressType + "-address-country-input",
      "data-test": "country",
      label: "Country",
      value: "Australia",
      maxLength: 40,
      disabled: !0
    })) : /*#__PURE__*/_react.default.createElement(_AddressV2AutoSuggest.Container, {
      "data-test": "autoSuggestContainer"
    }, /*#__PURE__*/_react.default.createElement(_AutoSuggest.default, {
      id: elemID,
      name: name,
      label: label,
      helpMessage: autoSuggestLabel,
      hasError: hasError,
      errorMessage: errorMessage.autoSuggest,
      disabled: disabled,
      placeholder: placeholder,
      showManualAddress: !1,
      initialValue: formattedAddress,
      suggestions: suggestions,
      onGetSuggestions: this.debouncedFetchSuggestions,
      onClearSuggestions: this.clearSuggestions,
      onSelect: this.selectValue,
      getSuggestionValue: this.getSuggestionValue,
      onValueChange: function onValueChange(e) {
        return _this2.handleChangeAfterSelection(e);
      },
      onBlur: function onBlur(suggestion, value) {
        return _this2.handleOnBlur(suggestion, value);
      },
      renderSuggestion: this.renderSuggestion,
      minLength: 4
      /* min query length for V2 api */

    })));
  };

  return AddressAutoSuggest;
}(_react.default.Component);

exports.default = AddressAutoSuggest;
AddressAutoSuggest.statesCodes = [{
  text: "",
  value: ""
}, {
  text: "NSW",
  value: "NSW"
}, {
  text: "ACT",
  value: "ACT"
}, {
  text: "QLD",
  value: "QLD"
}, {
  text: "VIC",
  value: "VIC"
}, {
  text: "TAS",
  value: "TAS"
}, {
  text: "SA",
  value: "SA"
}, {
  text: "NT",
  value: "NT"
}, {
  text: "WA",
  value: "WA"
}, {
  text: "OT",
  value: "OT"
}];
AddressAutoSuggest.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  apiKey: PropTypes.string,
  apiAddressType: PropTypes.string,
  apiDataSet: PropTypes.string,
  apiState: PropTypes.string,
  addressType: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  value: PropTypes.shape({
    addressLine: PropTypes.string,
    suburb: PropTypes.string,
    state: PropTypes.string,
    postcode: PropTypes.string,
    country: PropTypes.string,
    formattedAddress: PropTypes.string,
    nswPointReferenceId: PropTypes.string,
    validated: PropTypes.bool
  }).isRequired,
  initialLoadManual: PropTypes.bool.isRequired,
  emptyAddressValid: PropTypes.bool.isRequired,
  onAddressHasBecomeValid: PropTypes.func.isRequired,
  onAddressHasBecomeInvalid: PropTypes.func.isRequired,
  onSwitchToManual: PropTypes.func.isRequired,
  onSwitchToAutoSuggest: PropTypes.func.isRequired,
  validator: PropTypes.func.isRequired,
  helpMessage: PropTypes.string,
  manualModeMessage: PropTypes.string,
  manualAddressHeading: PropTypes.string,
  hasError: PropTypes.bool.isRequired,
  errorMessage: PropTypes.shape({
    autoSuggest: PropTypes.string,
    addressLine: PropTypes.string,
    suburb: PropTypes.string,
    state: PropTypes.string,
    postcode: PropTypes.string
  }),
  backendAPI: PropTypes.shape({
    getLatestSuggestions: PropTypes.func.isRequired,
    getDetailsById: PropTypes.func.isRequired
  }).isRequired
};
AddressAutoSuggest.defaultProps = {
  addressType: "residential",
  apiState: "ALL",
  validator: defaultAddressValidator,
  initialLoadManual: !1,
  onSwitchToManual: function onSwitchToManual() {},
  onSwitchToAutoSuggest: function onSwitchToAutoSuggest() {},
  emptyAddressValid: !1,
  helpMessage: "Start typing to search for an address",
  manualModeMessage: "Can\u2019t find the address?",
  manualAddressHeading: "Enter your address",
  hasError: !1,
  errorMessage: {},
  backendAPI: _nswPointV2Api.default
};

function debounce(func, wait) {
  var timerId;
  return function () {
    var _this3 = this;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    clearTimeout(timerId);
    timerId = setTimeout(function () {
      func.apply(_this3, args);
    }, wait);
  };
}